import { lazy, Suspense } from 'react';

import { Auth0ProviderWithNavigate } from './Auth0ProviderWithNavigate';
import { FullPageLoader } from './components/FullPageLoader/FullPageLoader';
import { Center, Loader } from '@mantine/core';

const Auth0AuthenticationGuard = lazy(() =>
  import('@/Auth0AuthenticationGuard').then((module) => ({
    default: module.Auth0AuthenticationGuard,
  }))
);

const HomePage = lazy(() =>
  import('@/pages/Home.page').then((module) => ({ default: module.HomePage }))
);
const PatientsPage = lazy(() =>
  import('@/pages/Patients.page').then((module) => ({ default: module.PatientsPage }))
);
const SessionsPage = lazy(() =>
  import('@/pages/Sessions.page').then((module) => ({ default: module.SessionsPage }))
);
const SessionPage = lazy(() =>
  import('@/pages/Session.page').then((module) => ({ default: module.SessionPage }))
);
const DashboardPage = lazy(() =>
  import('@/pages/Dashboard.page').then((module) => ({ default: module.DashboardPage }))
);
const CallbackPage = lazy(() =>
  import('@/pages/Callback.page').then((module) => ({ default: module.CallbackPage }))
);
const BookingPage = lazy(() =>
  import('@/pages/Booking.page').then((module) => ({ default: module.BookingPage }))
);
const InvoicesPage = lazy(() =>
  import('@/pages/Invoices.page').then((module) => ({ default: module.InvoicesPage }))
);
const AgendaConfigurationPage = lazy(() =>
  import('@/pages/AgendaConfiguration.page').then((module) => ({
    default: module.AgendaConfigurationPage,
  }))
);
const OAuth2Connections = lazy(() =>
  import('@/pages/OAuth2Connections').then((module) => ({ default: module.OAuth2Connections }))
);
const ProfilePage = lazy(() =>
  import('@/pages/Profile.page').then((module) => ({ default: module.ProfilePage }))
);

const MarketingPage = lazy(() =>
  import('@/pages/Marketing.page').then((module) => ({ default: module.MarketingPage }))
);

const CommunityPage = lazy(() =>
  import('@/pages/Community.page').then((module) => ({ default: module.CommunityPage }))
);

const ChooseConfiguration = lazy(() =>
  import('@/pages/ChooseConfiguration.page').then((module) => ({ default: module.ChooseConfiguration }))
);

const transition = () => {
  const main = document.getElementById('main');
  if (!main) return null;
  main.className = main.className + ' fade-out';
  return new Promise((res) => {
    setTimeout(() => res(null), 200);
  });
};

export const childrenRoutes = [
  {
    path: '/',
    element: <Auth0AuthenticationGuard component={HomePage} />,
    loader: transition,
  },
  {
    path: '/patients/',
    element: <Auth0AuthenticationGuard component={PatientsPage} />,
    loader: transition,
  },
  {
    path: '/patients/:patientId/sessions',
    element: <Auth0AuthenticationGuard component={SessionsPage} />,
    loader: transition,
  },
  {
    path: '/patients/:patientId/sessions/:sessionId',
    element: <Auth0AuthenticationGuard component={SessionPage} />,
    loader: transition,
  },
  {
    path: '/patients/:patientId/dashboard',
    element: <Auth0AuthenticationGuard component={DashboardPage} />,
    loader: transition,
  },
  {
    path: '/login',
    element: <Auth0AuthenticationGuard component={CallbackPage} />,
    loader: transition,
  },
  {
    path: '/callback',
    element: <CallbackPage />,
    loader: transition,
  },
  {
    path: '/agenda',
    element: <Auth0AuthenticationGuard component={BookingPage} />,
    loader: transition,
  },
  {
    path: '/agenda/invoices',
    element: <Auth0AuthenticationGuard component={InvoicesPage} />,
    loader: transition,
  },
  {
    path: '/agenda/configuration',
    element: <Auth0AuthenticationGuard component={ChooseConfiguration} />,
    loader: transition,
  },
  {
    path: '/agenda/configuration/:id',
    element: <Auth0AuthenticationGuard component={AgendaConfigurationPage} />,
    loader: transition,
  },
  {
    path: '/configuration/integrations',
    element: <Auth0AuthenticationGuard component={OAuth2Connections} />,
    loader: transition,
  },
  {
    path: '/profile',
    element: <Auth0AuthenticationGuard component={ProfilePage} />,
    loader: transition,
  },
  {
    path: '/marketing',
    element: <Auth0AuthenticationGuard component={MarketingPage} />,
    loader: transition,
  },
  {
    path: '/community',
    element: <Auth0AuthenticationGuard component={CommunityPage} />,
    loader: transition,
  },
];

export const protectedRoutes = {
  path: '/',
  element: (
    <Suspense fallback={<FullPageLoader />}>
      <Auth0ProviderWithNavigate />
    </Suspense>
  ),
  children: [
    ...childrenRoutes.map((route) => ({
      ...route,
      element: (
        <Suspense
          fallback={
            <Center>
              <Loader></Loader>
            </Center>
          }
        >
          {/* <GAPageTracker>{route.element}</GAPageTracker> */}
          {route.element}
        </Suspense>
      ),
    })),
  ],
};
